<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>值日安排使用说明:<br>
          <span>1、最多支持12个值日项目配置</span><br>
          <span>2、查询关键字:姓名。</span><br>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
      <template slot="pre_base_button">

      </template>
      <template slot="slot_c_weekday">
        <pre-select class="short0" @selectFunc="selectFunc0" v-bind:searchList="list_weekday" :selectValue="sel_weekday" />
      </template>
      <template slot="slot_c_duty">
        <pre-select class="short0" @selectFunc="selectFunc" v-bind:searchList="list_duty" :selectValue="sel_duty" />
      </template>
    </pre-base>
  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect
  } from '@/utils/loadhttpdata.js';
  export default {
    components: {
      "pre-base": () => import("../per_old/pre_base_2.vue"),
      'pre-select': () => import("../per_old/pre_select_one.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',

        // 组件
        show_tan: '0',
        show_item: '',
        // 下拉菜单
        list_weekday: [],
        sel_weekday: {},
        list_duty: [],
        sel_duty: {}
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init() {
        this.init_data = '';
        this.init_data = JSON.stringify({
          "control": "xz_ps_duty",
          "sel_action": 'exp_per_duty',
          "upd_action": 'p1_duty',
          "parm": [
            // {
            //   "name": "日期",
            //   "val": "",
            //   "key": "per_date",
            //   "type": "select",
            //   "class": "long1",
            //   "slot": "slot_c_weekday",
            //   "sel_name": "",
            //   "sel": "1",
            // },
            {
              "name": "日期",
              "val": "",
              "key": "per_date",
              "type": "date",
              "class": "long1",
              "sel": "1",
            },
            {
              "name": "内容",
              "val": "",
              "key": "duty_data",
              "type": "select",
              "class": "long1",
              "slot": "slot_c_duty",
              "sel_name": ""
            },
            {
              "name": "人员",
              "val": "",
              "key": "duty_user",
              "type": "text",
              "class": "long2",
              "sel": "2"
            }
          ],
          "parm_th": [{
              "name": "序号"
            }, {
              "name": "日期"
            }, {
              "name": "值日内容"
            },
            {
              "name": "值日人员"
            },
            {
              "name": "修改人"
            },
            {
              "name": "修改时间"
            }
          ]
        });

        this.list_weekday = [{
          "id": "1",
          "val": "星期一"
        }, {
          "id": "2",
          "val": "星期二"
        }, {
          "id": "3",
          "val": "星期三"
        }, {
          "id": "4",
          "val": "星期四"
        }, {
          "id": "5",
          "val": "星期五"
        }, {
          "id": "6",
          "val": "星期六"
        }, {
          "id": "7",
          "val": "星期日"
        }, ]

        this.loadClass('exp_per_class', 'duty')
      },
      refresh_data: function(type) {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data(type);
        });
      },
      refresh_children: function(type, id, val) {
        var that = this;
        if (type == 'slot_c_duty' || type == 'slot_c_weekday' ) {
          this.$nextTick(function() {
            that.$refs['mybase'].refesh_parm(type, id, val);
          });
        } else {
          this.$message({
            message: '类别=!' + type + ' 没有配置相关操作!',
            type: 'error'
          });
        }
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          case 'slot_c_weekday':
            this.selectFunc0(val);
            break;
          case 'slot_c_duty':
            this.selectFunc(val);
            break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      },
      /*****************************************************/
      selectFunc0: function(value) {
        // console.log('选择结果='+parm);
        for (var i = 0; i < this.list_weekday.length; i++) {
          if (this.list_weekday[i].id == value || this.list_weekday[i].val == value) {
            this.refresh_children('slot_c_weekday', this.list_weekday[i].id, this.list_weekday[i].val)
            break;
          }
        }
      },
      selectFunc: function(value) {
        // console.log('选择结果='+parm);
        for (var i = 0; i < this.list_duty.length; i++) {
          if (this.list_duty[i].id == value || this.list_duty[i].val == value) {
            this.refresh_children('slot_c_duty', this.list_duty[i].id, this.list_duty[i].val)
            break;
          }
        }
      },
      loadClass: function(action, type) {

        this.$post(
          api.http_method, Method_EasySelect('data_' + action, '', '', type)
        ).then(res => {
          // console.log(res);
          res = JSON.parse(res);
          if (res.data.status == 1) {
            this.list_duty = [];
            this.list_duty = res.data.data;
          }
        });
      }


    }
  };
</script>
<style scoped>
  .tab_body>td:nth-child(9) {
    display: none;
  }

  .tab_body>td:last-child {
    display: none;
  }
</style>
